__webpack_require__.p = "https://betterplace-assets.betterplace.org/packs/";